import React, { ReactNode } from 'react';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
import { AlertTitle, Box, CircularProgress,Snackbar,  Container, Typography, Alert, Breakpoint } from '@mui/material';

interface Props {
    children: ReactNode;
	disableFooter?: boolean;
	noScroll?: boolean;
	isLoading?: boolean;
	loadingMessage?: string;
	error?: any;
	disableGutters?: boolean;
	maxWidth?: false | Breakpoint | undefined;
}

export const FullPageLoader = ({loadingMessage}: {loadingMessage?: string}) => (
	<Box sx={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100dvh', flexDirection: 'column', gap: 2}}>
		<CircularProgress />
		{loadingMessage && <Typography variant="h6">{loadingMessage}</Typography>}
	</Box>
);

const PageWrapper = ({children, disableFooter, noScroll, isLoading, loadingMessage, error, disableGutters, maxWidth}: Props) => {
	if (error) {
		return <Snackbar open={!!error} autoHideDuration={6000}>
			<Alert severity="error">
				<AlertTitle>Error</AlertTitle>
				<Typography>
					{(error as any)?.data?.message}
				</Typography>
			</Alert>
		</Snackbar>;
	}
	return isLoading ? <FullPageLoader loadingMessage={loadingMessage} /> : <Container disableGutters={disableGutters} maxWidth={maxWidth}>
		<Box sx={noScroll ? {display:'flex', flexDirection: 'column', height: '100dvh', overflow: 'hidden'} : {}}>
			<PageHeader />
			{children}
			{!disableFooter && <PageFooter />}
		</Box>
	</Container>;
};

export default PageWrapper;